import React, { useEffect, useState } from 'react';
import FilterDropdown from '../../../components/Filter/components/FilterDropdown';
import { translate } from '../../../services/translate';
import { citizenService } from '../../../services/central-api/citizen';

interface Props {
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
    zIndex: number;
}

function BlockReasonDropdown({ value, setValue, zIndex }: Props) {
    const [items, setItems] = useState<{ label: string; value: number; }[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    async function getItems() {

        try {
            setIsLoading(true);
            const reason = await citizenService.getSimplifiedBlockReason();
            setItems(reason.map((reason) => {
                return {
                    value: reason.id,
                    label: reason.description
                };
            }));
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getItems();
    }, []);

    return (
        <FilterDropdown
            label={translate('title')}
            items={items}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            loading={isLoading}
        />
    );
}

export default BlockReasonDropdown;
